import { lazyLoad } from 'utils/loadable';

export const TaxManagement = lazyLoad(() => import('./index'));
